import React from 'react';
import { Link } from 'react-router-dom';
import AdSlot from '../AdSlot';
import postsData from '../../data/posts.json';

const BlogSidebar: React.FC = () => {
  const categories = ['SEO', 'Design', 'Platforms', 'Monetization', 'Hosting'];
  const recentPosts = postsData.slice(0, 4);

  return (
    <aside className="space-y-6">
      {/* Categories */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-4">
        <h3 className="font-semibold text-gray-900 mb-3">Categories</h3>
        <div className="space-y-2">
          {categories.map((category) => (
            <Link
              key={category}
              to={`/blog?category=${category.toLowerCase()}`}
              className="block px-3 py-2 text-sm text-gray-700 hover:text-sky-500 hover:bg-sky-50 rounded-lg transition-colors"
            >
              {category}
            </Link>
          ))}
        </div>
      </div>

      {/* Recent Posts */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-4">
        <h3 className="font-semibold text-gray-900 mb-3">Recent Posts</h3>
        <div className="space-y-3">
          {recentPosts.map((post: any) => (
            <Link
              key={post.id}
              to={`/post/${post.slug}`}
              className="block group"
            >
              <div className="flex space-x-3">
                <img
                  src={post.featuredImage}
                  alt={post.title}
                  className="w-16 h-16 object-cover rounded-lg flex-shrink-0"
                />
                <div className="flex-1 min-w-0">
                  <h4 className="text-sm font-medium text-gray-900 group-hover:text-sky-500 transition-colors line-clamp-2">
                    {post.title}
                  </h4>
                  <p className="text-xs text-gray-500 mt-1">{post.date}</p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>

      <AdSlot slot="sidebar" />


      {/* Newsletter */}
      <div className="bg-gradient-to-br from-sky-50 to-blue-50 rounded-xl border border-sky-200 p-6">
        <h3 className="font-semibold text-gray-900 mb-2">Newsletter</h3>
        <p className="text-sm text-gray-600 mb-4">
          Get weekly tips and resources delivered to your inbox.
        </p>
        <input
          type="email"
          placeholder="Your email"
          className="w-full px-4 py-2 rounded-lg border border-gray-200 mb-3 text-sm focus:outline-none focus:ring-2 focus:ring-sky-500"
        />
        <button className="w-full px-4 py-2 bg-gradient-to-r from-sky-500 to-blue-600 text-white rounded-lg text-sm font-medium hover:shadow-lg transition-all duration-300">
          Subscribe
        </button>
      </div>
    </aside>
  );
};

export default BlogSidebar;